




































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";

import VJsoneditor from "v-jsoneditor";
import { cloneDeep, isEqual, Dictionary } from "lodash";
import ConfigurationInternalsDocSchema from "@auditcloud/shared/lib/schemas/documents/ConfigurationInternalsDoc.schema.json";
import { ConfigurationInternalsDoc } from "@auditcloud/shared/lib/schemas";
import ajv from "@auditcloud/shared/lib/schemas/validator";

import { api } from "@/store/modules/configuration";
import { api as appApi } from "@/store/modules/app";
import { getterNs } from "../../utils/VuexHelper";
import { TodoAny } from "@auditcloud/shared/lib/utils/type-guards";
import { DocumentNames } from "@auditcloud/shared/lib/types/common";
@Component({
  components: { VJsoneditor },
})
export default class AConfigEditorInternals extends Vue {
  editedData: null | ConfigurationInternalsDoc = null;

  valid: boolean = true;
  options = {
    ajv,
    onValidationError: this.onValidationError,
    schema: ConfigurationInternalsDocSchema,
    templates: [],
    mode: "form",
    modes: ["tree", "form", "code", "text"],
  };

  segmentName = DocumentNames.CONFIG_INTERNALS;

  get storedData(): ConfigurationInternalsDoc | null {
    const getterName = getterNs(api, this.segmentName);
    if (this.segmentName in api.getters) {
      return cloneDeep(this.$store.getters[getterName]);
    } else {
      return null;
    }
  }
  @Watch("storedData", {
    immediate: true,
  })
  onSegmentNameChange(
    val: ConfigurationInternalsDoc | null,
    oldVal?: ConfigurationInternalsDoc | null
  ) {
    this.valid = true;
    this.editedData = cloneDeep(val);
  }

  get isDirty() {
    return !isEqual(this.storedData, this.editedData);
  }

  @Action(api.actions.updateConfiguration, { namespace: api.namespace })
  updateConfiguration!: (payload: {
    segment: string;
    data: Dictionary<any>;
  }) => Promise<any>;

  @Action(appApi.actions.setStatus, { namespace: appApi.namespace })
  setStatus!: (payload: string) => Promise<any>;

  importJsonConf() {
    console.log(
      "importJsonConf",
      this.segmentName,
      this.editedData,
      this.valid,
      this.isDirty
    );
    if (this.valid && this.isDirty && this.editedData !== null) {
      this.setStatus("loading");
      try {
        console.log("Start Save");
        const payload = { segment: this.segmentName, data: this.editedData };

        console.log("Importing", payload);

        this.updateConfiguration(payload);
        this.setStatus("success");
      } catch (error) {
        console.log("Json Parse failed:", error);
        this.setStatus("error");
      }
    }
  }
  onError(err: TodoAny) {
    console.error("AConfigEditorInternals:onError", err);
    this.valid = false;
  }
  onValidationError(errors: any[]) {
    this.valid = errors.length === 0;
    errors.forEach(error => {
      console.error("AConfigEditorInternals:ValidationError", error);
    });
  }
  onInput(data: null | ConfigurationInternalsDoc) {
    this.valid = true;
    this.editedData = data;
  }
}
